

 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

export  const    coursePageObject = { no:1, 
    id: generateTimestamp()+3,
    cardName:"PlayerCard1",
    cardType:"editable",
    myKey:`id-PlayerCard1-layout`,
   
        

          titleFonts:{ 
                headerFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } }, 
               titleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               subtitleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               tagsFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               buttonFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } }
               },
            outerCard:{ 
        
         layoutBG:{title:"Outer Card Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Outer Card Radius",
         topLeft:{title:"Top Left Radius",value:30,resolution:"px"},
         topRight:{title:"Top Right Radius",value:30,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:30,resolution:"px"}}},
        

         sidebarCard:{ 
         position:{title:"Sidebar Position.",position:"left"},

         layoutBG:{title:"Sidebar Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         progressBarColor:{title:"Course Progress BG Color",color:"rgba(144, 202, 249,0.21)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         progressBarInnerColor:{title:"Course Progress Inner Color",color:"rgba(163, 240, 227, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Sidebar Layout Radius",
         topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
         topRight:{title:"Top Right Radius",value:50,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}}},
         playerButton:{  
            
          bgColor:{title:"Player Button BG Color",color:"rgba(255,114,94,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Player Button Icon Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Player Button  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Player Button  Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
                }, 
          sidebarStatusTag:{  
            
          textColor:{title:"Status Tag Title Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Status Tag BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(144, 202, 249,1)"},alpha:1},
          border:{title:"Status Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:3,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Status Tag  Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
          
                }, 
          
        imageThumbnail: {   
         status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/t4YRDRbd/6390.jpg",
                  s3Key:"",
         aspectRatio:{title:"Image Crop Ratio",value:"4/3"},
          
         borderRadius:{title:"Lead Card Image Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
             },

          priceCard:{  
          toggleColor:{title:"Price & Installment Toggle Color ",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggleThumbColor:{title:"Price & Installment Thumb Color",color:"rgba(163, 240, 227, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggeleCardBgColor:{title:"Price & Installment BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
       
          textColor:{title:"Price Text Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Price Sub-Text Color",color:"rgba(18, 18, 18, 0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Price BG Color",color:"rgba(144, 202, 249,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Milestone Card Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
       
                },
            priceValidityCard:{  
            
          textColor:{title:"Price Validity Text Color",color:"rgba(255,114,94,0.9)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Price Validity BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Price Validity Icon Color",color:"rgba(255,114,94,0.9)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Price Validity Card Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
          primaryButton:{  
            
          textColor:{title:" Primary Button Title Color",color:"rgba(39, 39, 39, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Primary Button BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            border:{title:"Primary Button  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(149, 143, 218,1)",colors:{},alpha:1}},
          borderRadius:{title:"Primary Button Card Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
          secondaryButton:{ 
            
          textColor:{title:" Secondary Button Title Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Secondary Button BG Color",color:"rgba(149, 143, 218,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Secondary Button  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(149, 143, 218,1)",colors:{},alpha:1}},
          borderRadius:{title:"Secondary Button Card Radius",
          topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
          topRight:{title:"Top Right Radius",value:5,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
       
                },
                
          giftCourse:{ 
            
          textColor:{title:" Gift Course Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:" Gift Course Sub-Text Color",color:"rgba(133, 131, 131, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Gift Course BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Gift Course Icon Color",color:"rgba(114, 112, 112, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Gift Course Icon BG Color",color:"rgba(235, 235, 235, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Gift Course  Border",borderType:"dashed",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(230, 229, 229, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Gift Course Card Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
                },
          
                 mainCard:{ 
        
         layoutBG:{title:"Main Card Background Color",color:"rgba(252, 250, 250, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Main Card Radius",
         topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
         topRight:{title:"Top Right Radius",value:20,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}}},
        
          mainTitle:{  
            
          textColor:{title:"Course Title Color",color:"rgba(0, 0, 0, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Course Title BG Color",color:"rgba(252, 250, 250, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Course Title  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Course Title Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
          
                }, 
                 
         categoryTag:{  
            
          textColor:{title:"Category Text Color",color:"rgba(5, 5, 5, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           bgColor:{title:"Category BG Color",color:"rgba(252, 250, 250, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:"Category  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Category  Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
          
                },
                
          languageTag:{  
            
          textColor:{title:"Language Text Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Language BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Language Icon Color",color:"rgba(255,114,94,0.9)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Language  Radius",
          topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
          topRight:{title:"Top Right Radius",value:50,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
          
                },
                mainStatusTag:{  
            
          textColor:{title:"Main Status Label Text Color",color:"rgba(149, 143, 218, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           bgColor:{title:"Main Status Label BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Main Status Label Icon Color",color:"rgba(149, 143, 218, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Main Status Label  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255,114,94,0.9)",colors:{},alpha:1}},
          borderRadius:{title:"Main Status Label  Radius",
          topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
          topRight:{title:"Top Right Radius",value:50,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
          
                },
                typeTag:{  
                  
            
          textColor:{title:"Type Text Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           bgColor:{title:"Type BG Color",color:"rgba(255,114,94,0.9)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Type  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Type  Radius",
          topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
          topRight:{title:"Top Right Radius",value:50,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
          
                }, 
          shareIcon:{ 
        
          iconColor:{title:"Icon Icon Color",color:"rgba(80, 79, 79, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Icon Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Icon  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(223, 235, 238, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Icon  Radius",
          topLeft:{title:"Top Left Radius",value:50,resolution:"px"},
          topRight:{title:"Top Right Radius",value:50,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:50,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
          
                },
         whatsApproxIncluded:{  
           textColor:{title:"Whats Approx Included Title Color",color:"rgba(2, 2, 2, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Whats Approx Included  Sub-Text Color",color:"rgba(82, 80, 80, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Whats Approx Included  BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Whats Approx Included  Icon Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(223, 235, 238, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Whats Approx Included   Radius",
          topLeft:{title:"Top Left Radius",value:30,resolution:"px"},
          topRight:{title:"Top Right Radius",value:30,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:30,resolution:"px"}},
            
                }, 
                
          whatWillYouLearn:{  
          imageStatus:true,
          textColor:{title:"What Will You Learn Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"What Will You Learn  Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"What Will You Learn  BG Color",color:"rgba(249, 249, 249, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"What Will You Learn  Icon Color",color:"rgba(144, 202, 249, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"What Will You Learn  Image BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"dashed",borderWidth:{title:"Border Width",value:3,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"What Will You Learn   Radius",
          topLeft:{title:"Top Left Radius",value:30,resolution:"px"},
          topRight:{title:"Top Right Radius",value:30,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:30,resolution:"px"}},
          
                }, 
 
    contentOuter:{  
          imageStatus:true,
          textColor:{title:"Content Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Sub Course Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Content   BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"SubCourse Label   Icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"SubCourse Label   Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"dashed",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Content Outer layout  Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
                }, 


                
         milestoneCarousel:{  
            
          textColor:{title:"Milestone Carousel Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Milestone Carousel BG Color",color:"rgba(144, 202, 249,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Milestone Carousel Button icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Milestone Carousel  Button Icon BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Milestone Carousel Card Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
       
                },
        
  milestone:{  title:"Milestone",
            
          textColor:{title:"Milestone Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Milestone BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Milestone icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Milestone Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Milestone Card Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
       
                },
          section:{  title:"Section",
            
          textColor:{title:" Section Title Color",color:"rgba(39, 39, 39, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Section BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Section Icon Color",color:"rgba(43, 43, 43, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Section Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Section  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Section Card Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
       
                },
                
          chapter:{  title:"Chapter",
            
          textColor:{title:" Chapter Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Chapter BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Chapter Icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Chapter Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Chapter  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Chapter Card Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
          
                }, lessonCard:{ 
                lessonCardTheme:"T2",
                 title1:"Lesson",title2:"I have completed this lesson.",
            
          textColor:{title:" Show More Button BG Color",color:"rgba(27, 26, 26, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Show More Button BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Show More Icon & Text Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          progressBarColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,0.21)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          progressBarInnerColor:{title:"Show More Icon & Text Color",color:"rgba(163, 240, 227, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggleColor:{title:"Show More Icon & Text Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggleThumbColor:{title:"Show More Icon & Text Color",color:"rgba(163, 240, 227, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggeleCardBgColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Lead Card Button Radius",
          topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
          topRight:{title:"Top Right Radius",value:0,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},

         imageThumbnail: {   
         status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg",
                  s3Key:"",
         aspectRatio:{title:"Image Crop Ratio",value:"2/1"},
          
         borderRadius:{title:"Lead Card Image Radius",
         topLeft:{title:"Top Left Radius",value:5,resolution:"px"},
         topRight:{title:"Top Right Radius",value:5,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:5,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:5,resolution:"px"}},
         border:{title:"Image  Border",borderType:"double",
         borderWidth:{title:"Border Width",value:2,resolution:"px"}
        ,borderColor:{title:"Layout Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
         },
                },
         
       

         moreSectionsBtn:{  
            
          textColor:{title:"Show More Button Title Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Show More Button BG Color",color:"rgba(149, 143, 218, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(149, 143, 218, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Show More Button Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },

  targetAudience:{  
         
          textColor:{title:"Target Audience Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Target Audience   Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Target Audience   BG Color",color:"rgba(144, 202, 249,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Target Audience   Icon Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Target Audience    Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
                }, 

prerequisite:{  
           textColor:{title:"Prerequisite Title Color",color:"rgba(34, 34, 34, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Prerequisite   Sub-Text Color",color:"rgba(34, 34, 34, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Prerequisite   BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Prerequisite   Icon Color",color:"rgba(34, 34, 34, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Prerequisite    Radius",
          topLeft:{title:"Top Left Radius",value:25,resolution:"px"},
          topRight:{title:"Top Right Radius",value:25,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:25,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:25,resolution:"px"}},
          
                }, 
 highlights:{  
          textColor:{title:"Highlights Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Highlights   Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Highlights   BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Highlights   Icon Color",color:"rgba(255,114,94,0.9)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          icon2Color:{title:"Highlights  Top Icon Color",color:"rgba(150, 144, 218, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Skills   Icon BG Color",color:"rgba(255,114,94,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Highlights    Radius",
          topLeft:{title:"Top Left Radius",value:25,resolution:"px"},
          topRight:{title:"Top Right Radius",value:25,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:25,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:25,resolution:"px"}},
          
                }, 
  

skills:{  
          imageStatus:true,
          textColor:{title:"Skills Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Skills   Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Skills   BG Color",color:"rgba(255,114,94,0.051)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Skills   Icon Color",color:"rgba(144, 202, 249, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          icon2Color:{title:"Skills  Top Icon Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Skills   Icon BG Color",color:"rgba(144, 202, 249, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         icon2BgColor:{title:"Skills   Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Skills  Radius",
          topLeft:{title:"Top Left Radius",value:25,resolution:"px"},
          topRight:{title:"Top Right Radius",value:25,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:25,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:25,resolution:"px"}},
          
                }, 
               
  subCourseCardOuter:{  
          imageStatus:true,
          textColor:{title:"Sub Course Card Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Sub Course Card  Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Sub Course Card  BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Sub Course Card  Label   Icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Sub Course Card  Label   Icon BG Color",color:"rgba(235, 246, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"dashed",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Content Outer layout  Radius",
          topLeft:{title:"Top Left Radius",value:25,resolution:"px"},
          topRight:{title:"Top Right Radius",value:25,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:25,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:25,resolution:"px"}},
          
                },  
          
 

  subCourseCard:{  
          imageStatus:true,
          textColor:{title:"Sub Course Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Sub Course   BG Color",color:"rgba(144, 202, 249,0.21)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Sub Course Label   Icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Sub Course  Label   Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Sub Course layout  Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
         imageThumbnail: {   
         status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/HkNtgpwZ/6408.jpg",
                  s3Key:"",
         aspectRatio:{title:"Image Crop Ratio",value:"2/1"},
          
         borderRadius:{title:"Sub Course Image Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}},
         border:{title:"Image  Border",borderType:"double",
         borderWidth:{title:"Border Width",value:2,resolution:"px"}
        ,borderColor:{title:"Layout Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
         },
                },     
          
          
      
            subcoursePrimaryButton:{  
            
          textColor:{title:" Primary Button Title Color",color:"rgba(0, 0, 0, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Primary Button BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            border:{title:"Primary Button  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Primary Button Card Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
          subcourseSecondaryButton:{ 
            
          textColor:{title:" Secondary Button Title Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Secondary Button BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:"Secondary Button  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Secondary Button Card Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
        
    giftCard:{  
          textColor:{title:"Gift Course Card Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"Gift Course Card   Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"Gift Course Card   BG Color",color:"rgba(255,114,94,0.051)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Gift Course Card  Icon Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Gift Course Card   Icon BG Color",color:"rgba(255,114,94,0.9)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Gift Course Card  Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
                }, 
        




giftCardButton:{  
        
          textColor:{title:"Gift Course Card Button Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           bgColor:{title:"Gift Course Card  Button BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Gift Course Card Button Icon Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Gift Course Card Button  Icon BG Color",color:"rgba(144,202,249,0.9)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"dashed",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144,202,249,0.9)",colors:{},alpha:1}},
          borderRadius:{title:"Gift Course Card Button Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
                }, 
          
                




















    faqOuterCard:{  
          textColor:{title:"FAQ Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"FAQ  Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"FAQ BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"FAQ Icon Color",color:"rgba(150, 144, 218, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"FAQ Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"FAQ Radius",
          topLeft:{title:"Top Left Radius",value:25,resolution:"px"},
          topRight:{title:"Top Right Radius",value:25,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:25,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:25,resolution:"px"}},
          
                },
             faqInnerCard:{  
          textColor:{title:"FAQ Que Card Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          subTextColor:{title:"FAQ Que Card Sub-Text Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:"FAQ Que Card BG Color",color:"rgba(255,114,94,0.1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bg2Color:{title:"FAQ Que Card Inner Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"FAQ Que Card Icon Color",color:"rgba(255,114,94,0.7)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"FAQ Que Card Radius",
          topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
          topRight:{title:"Top Right Radius",value:20,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:20,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:20,resolution:"px"}},
          
                }
            
     
                       
         
        }